@if (user) {
    <lib-dropdown-panel [buttonTemplateRef]="userPanel" [source]="panel"></lib-dropdown-panel>
    <ng-template #userPanel>
        <div class="user-container">
            <app-user-avatar [user]="user"></app-user-avatar>
        </div>
    </ng-template>
}
